<div class="infraco-dashboard-action-render">
    <span class="icon-view status-background-icon" (click)="viewDocument()">
        <img tabindex="0" src="../../../../assets/images/icon-view.png" alt="view {{params.data.documentTitle}}"/>
        <span class="tooltiptext">View</span>
    </span>

    <span class="icon-download status-background-icon" (click)="download()">
        <img tabindex="0" src="../../../../assets/images/icon-download.svg" alt="download {{params.data.documentTitle}}"/>
        <span class="tooltiptext">Download</span></span>
</div>